// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:32:41.822Z
// Property: Quinn Residences at Dorchester Place (ID: 6767906449167648)
// Collections: 19 amenities, 15 floorplans (live), 13 photos, 21 POIs, 3 virtual tours, 6 office hours, 1 special offers (live), 19 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167648",
  "property_external_id": "1827735",
  "property_zillow_url": "https://www.zillow.com/apartments/covington-ga/quinn-residences-at-dorchester-place/CndPVj/",
  "property_apartments_url": "https://www.apartments.com/quinn-residences-at-dorchester-place-covington-ga/cw0dfee/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": "57164284979",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "quinn-residences-at-dorchester-place",
  "property_name": "Quinn Residences at Dorchester Place",
  "property_website_url": "https://www.live-dorchester.com",
  "property_domain": "https://www.live-dorchester.com",
  "property_address": "4112 Dorchester Dr SE",
  "property_full_address": "4112 Dorchester Dr SE, Covington, GA 30014",
  "property_address_1": "4112 Dorchester Dr SE",
  "property_address_2": null,
  "property_address_city": "Covington",
  "property_address_state": "GA",
  "property_address_zip_full": "30014",
  "property_address_zip": "30014",
  "property_address_country": "US",
  "property_address_county": "Newton County",
  "property_neighborhood_address": "Newton County",
  "property_address_latitude": "33.591432",
  "property_address_longitude": "-83.852013",
  "property_email": "quinley.A@quinnresidences-leasing.com",
  "property_phone": "(762) 248-6891",
  "property_call_tracking_phone": "762-248-6891",
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Single-family homes",
  "property_short_description": "<p><strong>Brand-new Covington rental homes with room to live your way.</strong> Explore spacious three-, four-, and five-bedroom <a href=\"/floor-plans\">floor plans</a> with polished finishes, smart-home technology, in-unit laundry, private fenced-in yards, and lawn maintenance—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Dorchester Place for yourself.</p>",
  "property_long_description": "<p><strong>Brand-new rental homes with room to live your way.</strong> At Quinn Residences at Dorchester Place, you get the space and privacy of a single-family home with the ease of a professionally managed community in Covington. Choose from spacious three-, four-, and five-bedroom <a href=\"/floor-plans\">floor plans</a> featuring stainless steel appliances, granite countertops, luxury flooring, smart-home technology, in-unit laundry, generous closets, and private fenced-in yards—plus lawn maintenance that keeps weekends simple.</p><p>Set just moments from Downtown Covington, you’re close to the Historic Square’s restaurants, boutiques, bookstores, and the local film-history Walk of Stars. Spend time outdoors along the Cricket Frog Trail, a paved rail-trail through Newton County, or explore nearby favorites like Mystic Grill, City Pharmacy, farmers market events, and the Georgia International Horse Park. When you want a modern Covington home base with polished finishes, outdoor space, and everyday convenience, Dorchester Place brings it together beautifully. Explore the <a href=\"/amenities\">amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see more.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-305d-7028-9a2e-24e8cc5f67eb.webp",
  "property_featured_image_media": {
    "alt_text": "A two-story house with a covered front porch and dormer windows.",
    "public_id": "019fec36-305d-7028-9a2e-24e8cc5f67eb",
    "storage_key": "property/6767906449167648/019fec36-305d-7028-9a2e-24e8cc5f67eb.webp",
    "width": 1280,
    "height": 900
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167648/01a0c01b-2ba2-770a-a42f-a25553b11390.mp4",
  "property_featured_video_media": {
    "public_id": "01a0c01b-2ba2-770a-a42f-a25553b11390",
    "storage_key": "property/6767906449167648/01a0c01b-2ba2-770a-a42f-a25553b11390.mp4",
    "thumbnail_key": "property/6767906449167648/01a0c01b-2ba2-770a-a42f-a25553b11390_thumb.webp",
    "size_bytes": 27139629,
    "classification": "Community",
    "title": "Explore Our Beautiful New Home Community",
    "description": "Take a scenic drone tour of our charming neighborhood, showcasing modern homes, well-maintained streets, and lush green surroundings. Discover the perfect place to call home."
  },
  "property_total_units": "82",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": "35",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "62.19512195121951",
  "property_admin_fee": "350",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit varies with application screening; a security deposit alternative is available. Required monthly charges: utility billing $11.99, concierge $10.95, landscaping $125, smart home package $35; renters insurance required. Application fee $100 per adult applicant; administrative fee $350 (one-time). See the Easy Fee Guide for the full schedule.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet; no more than two pets without written approval. Pet screening is mandatory before move-in.",
  "property_pet_policy_description": "Dogs and cats welcome, up to two pets. One-time pet fee $300 for one pet, $500 for two. Pet rent $35 per pet per month. 100-lb weight limit and breed restrictions apply; pet screening is required before move-in.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://live-dorchester.securecafe.com/onlineleasing/dorchester0/floorplans.aspx",
  "property_resident_portal_url": "https://live-dorchester.securecafenet.com/residentservices/dorchester0/userlogin",
  "property_apply_now_url": "https://live-dorchester.securecafe.com/onlineleasing/dorchester0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": null,
  "property_primary_logo_media": null,
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#a47d74",
  "property_secondary_color": "#433735",
  "property_font_color": "#606161",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 5",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "5",
  "property_bathrooms_range": "2.5 - 4",
  "property_bathrooms_min": "2.5",
  "property_bathrooms_max": "4",
  "property_sqft_range": "1739 - 2984",
  "property_sqft_min": "1739",
  "property_sqft_max": "2984",
  "property_price_range": "2400 - 3264",
  "property_price_min": "2400",
  "property_price_max": "3281",
  "property_available_units": 32,
  "property_facebook_url": "https://www.facebook.com/profile.php?id=61564435870484",
  "property_instagram_url": "https://www.instagram.com/livedorchester/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJzYVSqck19IgR40dOyzXijfM",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Quinn Residences at Dorchester Place",
  "property_home_romance_title": "Embrace Life in Your Perfect Home",
  "property_home_amenities_blurb": "<p><strong>Low-maintenance living with room to spread out.</strong> Quinn Residences at Dorchester Place pairs detached-home privacy with private fenced-in yards and included lawn maintenance. Inside each three-, four-, and five-bedroom rental home, enjoy granite countertops, stainless steel appliances, luxury flooring, smart-home features, in-unit laundry, and spacious closets—plus easy access to Cricket Frog Trail for outdoor time close to home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Detached rental homes with room to choose.</strong> Explore three-, four-, and five-bedroom floor plans in Covington, GA, with open living areas, granite countertops, stainless steel appliances, luxury flooring, smart-home features, in-unit laundry, spacious closets, and fenced-in yards. Compare current layouts, pricing, and availability to find the space that fits your everyday routine.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture detached rental living in Covington.</strong> Preview bright kitchens with granite countertops and stainless steel appliances, open living spaces with luxury flooring, and spacious bedrooms finished with polished everyday details. Outside, fenced-in yards, manicured lawns, and green space bring the full Dorchester Place look into focus.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Covington charm, close to everything.</strong> Dorchester Place puts coffee runs, local shops, and evenings on the Historic Square within easy reach, with seasonal events, farmers market finds, and Newton County scenery nearby. Spend time at Turner Lake Park, hop on the paved Cricket Frog Trail, or take I-20 toward Conyers and Atlanta—then come home to a quieter setting with space to unwind.</p>",
  "property_home_reviews_blurb": "<p><strong>See Dorchester Place through real resident feedback.</strong> Browse comments and ratings that highlight everyday comfort, the rental home experience, and the details that stand out over time. These firsthand perspectives can help you compare options, picture life at Quinn Residences at Dorchester Place, and take the next step with more confidence.</p>",
  "property_neighborhood_blurb": "<p><strong>Small-town texture, everyday convenience.</strong> From Dorchester Place, your Covington routine can move from coffee and errands to an evening on the Historic Square without losing that quieter, tucked-away feel. Browse local shops, catch seasonal events around Square Park or Legion Field, and make weekend stops at Heirloom Park’s Farmers Market when it’s in season. For fresh air, Turner Lake Park brings trails, fishing, picnic spots, and ballfields nearby, while the Cricket Frog Trail adds an easy paved route through Newton County scenery. With I-20 access close by, you’re connected to Conyers, Atlanta, and daily essentials—then back to a detached rental home with room to unwind.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make home feel effortless.</strong> At Quinn Residences at Dorchester Place, everyday convenience starts at your front door—with detached-home privacy, a private fenced-in yard, and lawn maintenance handled for you. Inside, polished finishes like granite countertops, stainless steel appliances, luxury flooring, and smart-home technology give each three-, four-, or five-bedroom layout a modern, move-in-ready feel.</p><p>Use the extra room for work, hosting, hobbies, or quiet downtime, then let in-unit laundry and spacious closets keep routines simple. Nearby access to Cricket Frog Trail adds an easy outdoor option without turning amenities into a long checklist. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how these Covington rental homes bring comfort and low-maintenance living together.</p>",
  "property_applynow_blurb": "<p><strong>Your new Covington home starts here.</strong> Quinn Residences at Dorchester Place pairs brand-new three-, four-, and five-bedroom rental homes with polished finishes, smart-home technology, in-unit laundry, private fenced-in yards, and professional management. Find the space, privacy, and everyday ease you’ve been looking for—then start your application online.</p>",
  "property_contactus_blurb": "<p><strong>Questions about Dorchester Place?</strong><br>Our leasing team is here to help with brand-new three-, four-, and five-bedroom rental homes in Covington, from polished finishes and private fenced-in yards to professionally managed convenience. Reach out today for answers, availability, or directions.</p>",
  "property_faqs_blurb": "<p><strong>Have questions about Dorchester Place?</strong> Start here for quick answers about our brand-new rental homes, leasing details, community features, and everyday living in Covington. If you need anything else, the leasing team is happy to help you find the information you need.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits how you live.</strong> Quinn Residences at Dorchester Place offers a wide selection of detached three-, four-, and five-bedroom rental homes in Covington, with options that range from streamlined everyday comfort to larger designs with additional baths and flexible space. As you compare floor plan cards, look for details that make each home feel polished and practical: open living areas, granite countertops, stainless steel appliances, luxury flooring, smart-home features, in-unit laundry, spacious closets, and a fenced-in yard. Browse current pricing and availability, then picture where your workday setup, weekend hosting, storage, and quiet downtime can all come together. Ready for a closer look? <a href=\"/schedule-a-tour\">Schedule a tour</a>.</p>",
  "property_gallery_blurb": "<p><strong>See Dorchester Place before you step inside.</strong> Browse the gallery for a closer look at detached rental homes where bright kitchens, granite countertops, and stainless steel appliances photograph beautifully from every angle. Follow the images into open living spaces with luxury flooring, spacious bedrooms, and everyday details that make each layout feel polished without feeling fussy.</p><p>Outside, snapshots of fenced-in yards, manicured lawns, and community green space help you picture the balance of room, outdoor space, and low-maintenance living in Covington. When a floor plan catches your eye, compare <a href=\"/floor-plans\">available layouts</a> or go deeper with <a href=\"/virtual-tours\">virtual tours</a>.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Dorchester Place on the map.</strong> See available three-, four-, and five-bedroom rental homes, then zoom out to discover nearby Downtown Covington dining, shopping, trails, events, and local favorites—all from a modern home base with space, privacy, and everyday convenience.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, whiskers, and everyday routines.</strong><br>At Quinn Residences at Dorchester Place, pet-friendly living feels easy because your home gives you more than a door to the hallway. Step outside to a private fenced-in yard for fresh air close to home, head to the walking and biking trails when it is time to stretch your legs, and come back to a detached rental home with lawn maintenance handled for you. Inside, efficient appliances, in-home laundry, and comfortable climate control help simplify muddy-paw days, hot afternoons, and cozy nights in. Cats and dogs are welcome within the community’s pet guidelines, with details listed below so you can plan with confidence. Want to picture the space your pet will share with you? Browse <a href=\"/amenities\">pet-friendly features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_referafriend_blurb": "<p><strong>Share the space, privacy, and ease you love.</strong> Invite a friend to discover brand-new rental homes at Dorchester Place, with spacious floor plans, polished finishes, smart-home technology, private fenced-in yards, and professional management that helps keep everyday living simple.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Dorchester Place.</strong><br>Enjoy the ease of a professionally managed community from your account portal. Log in to pay rent, submit maintenance requests, and manage details for your brand-new rental home—so everyday needs stay as simple as weekends with lawn maintenance included.</p>",
  "property_reviews_blurb": "<p><strong>Hear what living here feels like from the people who know it best.</strong> As you explore reviews for Quinn Residences at Dorchester Place, you’ll find firsthand perspectives on the rental home experience, day-to-day comfort, and what stands out to residents over time.</p><p>Use these ratings and comments to get a clearer sense of the community before you schedule a visit, compare floor plans, or reach out with questions. Real feedback can help you picture the details that matter most to you—so you can decide with confidence.</p>",
  "property_created_at": "1786374232149",
  "property_scheduletour_blurb": "<p><strong>See Dorchester Place in person.</strong> Tour brand-new three-, four-, and five-bedroom rental homes with polished finishes, smart-home technology, in-unit laundry, generous closets, and private fenced-in yards. Schedule your visit and picture the space, privacy, and easy upkeep of a professionally managed Covington community.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong> The leasing team will follow up soon with more details. In the meantime, Quinn Residences at Dorchester Place brings together brand-new three-, four-, and five-bedroom rental homes, polished finishes, smart-home technology, private fenced-in yards, and professional management in a convenient Covington setting.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "© 2026 Quinn Residences. All rights reserved.",
  "property_seo_title_home": "Homes for Rent in Covington, GA | Dorchester Place",
  "property_seo_description_home": "Discover 3-, 4-, and 5-bedroom homes for rent in Covington, GA, at Dorchester Place. Enjoy modern finishes, private yards, and spacious layouts. Tour today!",
  "property_seo_title_floorplans": "3–5 Bedroom Rental Homes in Covington, GA",
  "property_seo_description_floorplans": "Explore 3-, 4-, and 5-bedroom rental homes in Covington, GA, at Dorchester Place. Find spacious floor plans with modern features and room to make your own.",
  "property_seo_title_amenities": "Rental Home Amenities in Covington, GA",
  "property_seo_description_amenities": "Explore rental homes in Covington, GA, with private fenced yards, smart-home technology, stainless steel appliances, and in-unit laundry at Dorchester Place.",
  "property_seo_title_gallery": "Covington, GA Rental Home Photos | Dorchester",
  "property_seo_description_gallery": "Picture life at Dorchester Place. Browse photos of our spacious rental homes in Covington, GA, featuring modern interiors, private yards, and inviting spaces.",
  "property_seo_title_virtualtours": "Virtual Tours of Covington, GA Rental Homes",
  "property_seo_description_virtualtours": "Explore Dorchester Place from anywhere with virtual tours of our rental homes in Covington, GA. Discover spacious layouts and modern features online.",
  "property_seo_title_interactivemap": "Explore Available Homes in Covington, GA",
  "property_seo_description_interactivemap": "Find your next rental home at Dorchester Place. Explore available homes in Covington, GA, compare floor plans, and discover a layout that fits your needs.",
  "property_seo_title_neighborhood": "Homes Near Downtown Covington, GA | Dorchester",
  "property_seo_description_neighborhood": "Explore rental homes near downtown Covington, GA, at Dorchester Place. Discover nearby shopping, dining, Covington Square, and outdoor recreation.",
  "property_seo_title_contact": "Contact Dorchester Place | Covington, GA Homes",
  "property_seo_description_contact": "Have questions about rental homes in Covington, GA? Contact Dorchester Place for information about floor plans, availability, amenities, and leasing.",
  "property_seo_title_faqs": "FAQs | Apartments in Covington, GA",
  "property_seo_description_faqs": "Unearth the answers you seek at Quinn Residences in Covington, GA. From spacious layouts to modern amenities, our FAQs clarify life in your dream home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Covington, GA",
  "property_seo_description_reviews": "Experience life at Quinn Residences in Covington, GA. Our spacious homes and luxury amenities create a vibrant community. See what our residents love about us!",
  "property_seo_title_applynow": "Apply for a Rental Home in Covington, GA",
  "property_seo_description_applynow": "Ready to make your move? Apply online for a rental home at Dorchester Place in Covington, GA. Explore available floor plans and take the next step.",
  "property_seo_title_residentaccess": "Resident Portal | Dorchester Place Covington",
  "property_seo_description_residentaccess": "Access the Dorchester Place resident portal to manage your rental home account, submit maintenance requests, and find helpful resident resources.",
  "property_seo_title_referafriend": "Refer A Friend | Quinn Residences at Dorchester Place",
  "property_seo_description_referafriend": "Refer a friend to Quinn Residences at Dorchester Place in Covington, GA! Great friends make great neighbors—share the love of community today!",
  "property_seo_title_scheduletour": "Tour Rental Homes in Covington, GA | Dorchester",
  "property_seo_description_scheduletour": "Ready to explore Dorchester Place? Schedule a tour of our 3-, 4-, and 5-bedroom rental homes in Covington, GA, and discover your next home.",
  "property_seo_title_privacy": "Privacy Policy | Quinn Residences at Dorchester Place",
  "property_seo_description_privacy": "At Quinn Residences at Dorchester Place, your privacy matters. Learn how we protect your personal information in our comprehensive privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Quinn Residences at Dorchester Place",
  "property_seo_description_accessibility": "At Quinn Residences at Dorchester Place, we prioritize digital inclusion and accessibility for all. Experience a welcoming community in Covington, GA today!",
  "property_seo_title_sitemap": "Sitemap | Quinn Residences at Dorchester Place",
  "property_seo_description_sitemap": "Navigate Quinn Residences at Dorchester Place in Covington, GA. Find your perfect apartment and discover our community's offerings in our easy-to-use sitemap!",
  "property_seo_title_thankyou": "Thank You | Dorchester Place Covington, GA",
  "property_seo_description_thankyou": "Thank you for contacting Dorchester Place in Covington, GA. Our leasing team looks forward to connecting with you about our rental homes.",
  "property_seo_title_pets": "Pet-Friendly Rental Homes in Covington, GA",
  "property_seo_description_pets": "Discover pet-friendly rental homes in Covington, GA, at Dorchester Place. Explore spacious layouts, private fenced yards, and community pet policies.",
  "property_updated_at": "1793289077551",
  "amenities": [
    {
      "id": "ec_0a9309c80ac2373bf5ce206c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "129124797",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff7f0f920df13c3bdda1877b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "129124801",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09963a2efa3a15b15f1ee41a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "129124828",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_49f3752a2e8e859dbf863725",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "129124824",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3ad66040658a281556e9556",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "129124820",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f648b47697dd6f8f9bffefaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "129124823",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa686c7c45114ddd8892bfa1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "122615601",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c79bebd8b50b9f635285c0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "122615599",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a260acf11a98a78d86e8e36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "122615600",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4bfe8241fa9ef55387ff7eb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "122615598",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d465c41c5de1e131f7f05fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "122615595",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ae41d1d23b448fd18f2c798",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "122615596",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30f9cd82a002288587a9fc1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "122615597",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fe1318385b8812abdb4a1ce4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "122615591",
      "title": "Cricket Frog Trail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d4626e6476b8fabd1f29487",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "122615593",
      "title": "Lawn Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed69bf8bf0dbd305ecaf710e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "122615594",
      "title": "Private Fenced-In Yard",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5edcc6ea307ff3cc4e89e5dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "129124840",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d144bf322082d9757aeeba05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "129124847",
      "title": "Smart-Home Technology",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a11e29bddb94aa676e09862",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "129124852",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_b9434b198c52210ec44bceaf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-305d-7028-9a2e-24e8cc5f67eb.webp",
      "image_media": {
        "alt_text": "A two-story house with a covered front porch and dormer windows.",
        "public_id": "019fec36-305d-7028-9a2e-24e8cc5f67eb",
        "storage_key": "property/6767906449167648/019fec36-305d-7028-9a2e-24e8cc5f67eb.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Charming two-story home featuring a welcoming covered front porch, perfect for enjoying the outdoors. This residence offers ample living space and classic architectural details.",
      "link": "false",
      "alt_text": "A house with a grey roof and a small front yard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Aspen-exterior-1.jpg"
    },
    {
      "id": "ec_5ce304e64d53718cfa65bdba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-539c-75ee-8bb0-11df06489424.webp",
      "image_media": {
        "alt_text": "Open concept living area and kitchen with hardwood floors, granite countertops, and stainless steel appliances.",
        "public_id": "019fec36-539c-75ee-8bb0-11df06489424",
        "storage_key": "property/6767906449167648/019fec36-539c-75ee-8bb0-11df06489424.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area seamlessly flows into a modern kitchen featuring granite countertops, stainless steel appliances, and a breakfast bar.",
      "link": "false",
      "alt_text": "A spacious living room with a staircase and a kitchen area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Vera-LivingRoom.jpg"
    },
    {
      "id": "ec_56259a7023fd48410e892db4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-3b6f-75dd-8773-9a737fa92916.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and an island.",
        "public_id": "019fec36-3b6f-75dd-8773-9a737fa92916",
        "storage_key": "property/6767906449167648/019fec36-3b6f-75dd-8773-9a737fa92916.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring ample cabinet space, sleek granite countertops, and modern stainless steel appliances. The central island offers additional prep space and a breakfast bar.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and a granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Hemingway-Kitchen.jpg"
    },
    {
      "id": "ec_f8032dec1dc7c3e773f9cf5e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-4e0c-70a5-8d88-88ba3c9ce7ae.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and an island.",
        "public_id": "019fec36-4e0c-70a5-8d88-88ba3c9ce7ae",
        "storage_key": "property/6767906449167648/019fec36-4e0c-70a5-8d88-88ba3c9ce7ae.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, elegant granite countertops, a convenient island, and stainless steel appliances, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "A modern kitchen with white cabinets and a wooden floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Vera-Kitchen.jpg"
    },
    {
      "id": "ec_d5c6040f1e0a20f353240001",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-48ec-7323-abd7-1e9939b3444d.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with light wood floors and white walls.",
        "public_id": "019fec36-48ec-7323-abd7-1e9939b3444d",
        "storage_key": "property/6767906449167648/019fec36-48ec-7323-abd7-1e9939b3444d.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Open-concept living space featuring gleaming light wood floors, ample natural light, and a modern kitchen island, perfect for entertaining.",
      "link": "false",
      "alt_text": "A room with wooden floors and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Hemingway-LivingRoom.jpg"
    },
    {
      "id": "ec_fb5314116453ff9056385cdf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-3cd2-743d-b5ca-c11ba613ee44.webp",
      "image_media": {
        "alt_text": "Modern open-concept living space with a kitchen island, stainless steel appliances, and hardwood floors.",
        "public_id": "019fec36-3cd2-743d-b5ca-c11ba613ee44",
        "storage_key": "property/6767906449167648/019fec36-3cd2-743d-b5ca-c11ba613ee44.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a contemporary kitchen with a large island, stainless steel appliances, and ample counter space. Perfect for entertaining.",
      "link": "false",
      "alt_text": "A spacious room with wooden floors and a kitchen area with white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Aspen-LivingRoom.jpg"
    },
    {
      "id": "ec_5ab29b300c0da8bdc208e616",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-3d93-70ed-9a97-2d20d4698bf9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light gray cabinets, stainless steel appliances, and granite countertops, adjacent to a staircase.",
        "public_id": "019fec36-3d93-70ed-9a97-2d20d4698bf9",
        "storage_key": "property/6767906449167648/019fec36-3d93-70ed-9a97-2d20d4698bf9.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek light gray cabinetry, granite countertops, and stainless steel appliances. Open to a dining area and a convenient staircase.",
      "link": "false",
      "alt_text": "A kitchen with wooden floors and a staircase with wooden steps.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Aspen-Kitchen.jpg"
    },
    {
      "id": "ec_3415a206fc13dbbbdc88f193",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-557a-70da-9438-8495b82fb4cd.webp",
      "image_media": {
        "alt_text": "Bedroom with a tray ceiling and a ceiling fan, and two dark doors.",
        "public_id": "019fec36-557a-70da-9438-8495b82fb4cd",
        "storage_key": "property/6767906449167648/019fec36-557a-70da-9438-8495b82fb4cd.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a decorative tray ceiling with a ceiling fan and elegant crown molding. Two dark wood doors lead to other areas of the apartment.",
      "link": "false",
      "alt_text": "A room with a ceiling fan and wooden flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Vera-PrimaryBedroom.jpg"
    },
    {
      "id": "ec_3d3328e327d277a6ad2563b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-4a8d-731f-acee-bfb7902871af.webp",
      "image_media": {
        "alt_text": "Spacious bathroom with double vanity, large mirror, walk-in shower, and separate soaking tub. Opens to bedroom.",
        "public_id": "019fec36-4a8d-731f-acee-bfb7902871af",
        "storage_key": "property/6767906449167648/019fec36-4a8d-731f-acee-bfb7902871af.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Experience luxury in our spacious bathrooms, featuring elegant double vanities, a walk-in shower, and a separate soaking tub. This master bathroom opens to a beautifully appointed bedroom.",
      "link": "false",
      "alt_text": "A bathroom with a wooden floor and white walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Hemingway-PrimaryBathroom.jpg"
    },
    {
      "id": "ec_be7f5c2eef6232efb132c10a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-3c91-706e-9a69-08144e2f7311.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, large mirror, and glass-enclosed shower.",
        "public_id": "019fec36-3c91-706e-9a69-08144e2f7311",
        "storage_key": "property/6767906449167648/019fec36-3c91-706e-9a69-08144e2f7311.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a double vanity with quartz countertops, a large mirror, and a sleek glass-enclosed shower. Ample storage and elegant finishes create a spa-like experience.",
      "link": "false",
      "alt_text": "A bathroom with a sink and a mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Aspen-PrimaryBath.jpg"
    },
    {
      "id": "ec_8243a1add00746051178351a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-58e3-755b-8e59-a35104c55d25.webp",
      "image_media": {
        "alt_text": "Double vanity with white countertops and white cabinets, leading to a bedroom. Bathroom features a walk-in shower.",
        "public_id": "019fec36-58e3-755b-8e59-a35104c55d25",
        "storage_key": "property/6767906449167648/019fec36-58e3-755b-8e59-a35104c55d25.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious bathroom with a double vanity, ample counter space, and a walk-in shower. The adjacent bedroom is visible through the open doorway.",
      "link": "false",
      "alt_text": "A bathroom with a vanity and a mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Vera-PrimaryBath.jpg"
    },
    {
      "id": "ec_b7062e40aeb26997a44a04c6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-3cc6-7758-972b-8d6509273cdb.webp",
      "image_media": {
        "alt_text": "Exterior of a light blue single-family home with a covered front porch and a sidewalk leading to the front door.",
        "public_id": "019fec36-3cc6-7758-972b-8d6509273cdb",
        "storage_key": "property/6767906449167648/019fec36-3cc6-7758-972b-8d6509273cdb.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Charming single-family home with a welcoming covered front porch, perfect for relaxing outdoors. Features a well-maintained lawn and landscaping.",
      "link": "false",
      "alt_text": "A white house with a blue roof and a front porch.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Hemingway-Exterior.jpg"
    },
    {
      "id": "ec_a00e68a792fd61e60790d513",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-4f86-7709-be0b-be460efb355d.webp",
      "image_media": {
        "alt_text": "Exterior front view of a modern farmhouse style house with light blue siding and white trim.",
        "public_id": "019fec36-4f86-7709-be0b-be460efb355d",
        "storage_key": "property/6767906449167648/019fec36-4f86-7709-be0b-be460efb355d.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Charming exterior of a modern farmhouse style home, featuring light blue siding, white columns, and a welcoming front entrance.",
      "link": "false",
      "alt_text": "A white house with a grey roof and a blue door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Vera-Exterior.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_33a9c193-b352-4ebc-95f5-f86c1db58f86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Mystic Grill",
      "poi_type": "Restaurants",
      "poi_address": "1116 Clark St SW, Covington, GA 30014, USA",
      "poi_short_description": "Creative Southern cuisine served in a stylish, vintage-chic setting with rooftop seating.",
      "poi_long_description": "Diners like this restaurant's delicious and flavorful food, with popular choices including the sweet tea fried chicken, fried green tomatoes, and thick burgers. They also highlight the reasonable prices and the unique atmosphere, especially for fans of \"The Vampire Diaries.\" Guests mention the staff are friendly, attentive, and provide excellent service, often offering helpful recommendations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-a895-7357-8d4f-38881e36ac0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-a895-7357-8d4f-38881e36ac0f",
        "storage_key": "property/6767906449167648/019fec33-a895-7357-8d4f-38881e36ac0f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mysticgrill.restaurant/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13040928396670937534&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mystic-grill",
      "poi_latitude": "33.5970837",
      "poi_longitude": "-83.8598481",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 770-728-1670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce72-720d-8e18-dd4bd592b192.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce72-720d-8e18-dd4bd592b192",
        "storage_key": "property/6767906449167648/019fec33-ce72-720d-8e18-dd4bd592b192.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ_g4_WI09IgRvingcEiv-rQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_9331a958-a2ff-4a06-8426-d451a10b4ca5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4102 US-278, Covington, GA 30014, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this restaurant offers great food, including delicious chicken sandwiches, strips, and fries, with many highlighting the new pretzel bun chicken sandwich. They also mention the fast, well-organized service and the clean dining areas and restrooms. Others appreciate the friendly and attentive staff who provide excellent guidance and training tips.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-a440-766e-9447-9f5281b83a97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-a440-766e-9447-9f5281b83a97",
        "storage_key": "property/6767906449167648/019fec33-a440-766e-9447-9f5281b83a97.webp",
        "width": 1280,
        "height": 981
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ga/covington-ga?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2293714500586411781&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "33.60321330000001",
      "poi_longitude": "-83.8657236",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-787-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce72-720d-8e18-dd4bd592b192.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce72-720d-8e18-dd4bd592b192",
        "storage_key": "property/6767906449167648/019fec33-ce72-720d-8e18-dd4bd592b192.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Wq_Bok09IgRBZedhy_p1B8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_d36b1f24-4677-482f-a6c6-9ab1ca686972",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "6112 Pavilion Way, Covington, GA 30014, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "Diners consistently praise this steakhouse for its delicious food, particularly the steaks, Wild West shrimp, and Parmesan-crusted chicken. The excellent and attentive service provided by the staff is also frequently highlighted.\n\nSome reviews mention the food can be incorrectly prepared.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-a88f-7108-99b0-96753344e3b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-a88f-7108-99b0-96753344e3b4",
        "storage_key": "property/6767906449167648/019fec33-a88f-7108-99b0-96753344e3b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/ga/covington/covington/5244?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:covington-ga-5244_pl:locurl_rd:1196",
      "poi_directions_map_url": "https://maps.google.com/?cid=8122017511437338815&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "33.605857",
      "poi_longitude": "-83.87254899999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-625-4320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce72-720d-8e18-dd4bd592b192.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce72-720d-8e18-dd4bd592b192",
        "storage_key": "property/6767906449167648/019fec33-ce72-720d-8e18-dd4bd592b192.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEVM7AmM09IgRv4i59OQzt3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_727d0d88-0e88-4b66-b96b-53c690adc566",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6138 Pavillion Way, Covington, GA 30014, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Diners like this restaurant's delicious Italian-American comfort food, including chicken alfredo, lasagna, and endless breadsticks and salad. They also highlight the friendly, attentive staff and the clean, inviting atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-a716-76ef-b851-13a1c1b89be1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-a716-76ef-b851-13a1c1b89be1",
        "storage_key": "property/6767906449167648/019fec33-a716-76ef-b851-13a1c1b89be1.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ga/covington/covington-ga-near-covington-crossings/6509?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:covington-ga-6509_pl:locurl_rd:1931",
      "poi_directions_map_url": "https://maps.google.com/?cid=2982032219875720032&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "33.606377",
      "poi_longitude": "-83.8732873",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 470-441-3259",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce72-720d-8e18-dd4bd592b192.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce72-720d-8e18-dd4bd592b192",
        "storage_key": "property/6767906449167648/019fec33-ce72-720d-8e18-dd4bd592b192.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_e3OjU19IgRYDt2JoFOYik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_2165a357-c57d-4f13-9fee-a109fcca31a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "13171 GA-142, Covington, GA 30014, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Customers consistently praise this store for its wide selection of building materials and products, alongside its organized and clean environment. The knowledgeable staff are frequently mentioned for providing excellent service.\n\nSome reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-a4a7-7118-9750-dd8ac756435d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-a4a7-7118-9750-dd8ac756435d",
        "storage_key": "property/6767906449167648/019fec33-a4a7-7118-9750-dd8ac756435d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Covington/GA/Covington/30014/165?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10455763989144091622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.6152161",
      "poi_longitude": "-83.8257331",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-784-0197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce33-700b-adc3-d10723c664fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce33-700b-adc3-d10723c664fc",
        "storage_key": "property/6767906449167648/019fec33-ce33-700b-adc3-d10723c664fc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJB-VlAhUz9IgR5jtBfPNVGpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_79bba400-8e37-4436-9e4e-82b028990153",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Publix Super Market at Covington Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "12701 Town Center Dr, Covington, GA 30014, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this grocery store is very clean and well-stocked, offering a wide selection of fresh produce, meat, and seafood, along with delicious deli items like subs and pasta salads. They also highlight the friendly, professional, and helpful staff, who provide excellent service. Visitors appreciate the competitive prices, especially the \"buy one get one free\" deals, and the convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-a1c8-7639-aa50-8fe4c13286ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-a1c8-7639-aa50-8fe4c13286ba",
        "storage_key": "property/6767906449167648/019fec33-a1c8-7639-aa50-8fe4c13286ba.webp",
        "width": 1128,
        "height": 846
      },
      "poi_business_url": "https://www.publix.com/?utm_medium=maps&utm_source=google&utm_content=psm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=10692552167580276216&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-covington-town-center",
      "poi_latitude": "33.6239704",
      "poi_longitude": "-83.8391935",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-385-5705",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce32-70ab-9f4b-5f4deea7748b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce32-70ab-9f4b-5f4deea7748b",
        "storage_key": "property/6767906449167648/019fec33-ce32-70ab-9f4b-5f4deea7748b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJye7BB9Qz9IgR-JX0eouTY5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_020776fb-f427-48e8-8556-3099da2962c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "11152 GA-142, Covington, GA 30014, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this grocery store offers fresh vegetables, fruit, meat, and fish, along with a wide variety of non-GMO products. They also highlight the competitive and reasonable prices, making it a great option for those on a budget. Others mention the helpful staff and well-stocked shelves, even during busy times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-a582-73be-a95f-e893f2bfea0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-a582-73be-a95f-e893f2bfea0e",
        "storage_key": "property/6767906449167648/019fec33-a582-73be-a95f-e893f2bfea0e.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ga/covington/11152-highway-142-ne/l924",
      "poi_directions_map_url": "https://maps.google.com/?cid=3267581049707766061&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "33.607759",
      "poi_longitude": "-83.826698",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce32-70ab-9f4b-5f4deea7748b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce32-70ab-9f4b-5f4deea7748b",
        "storage_key": "property/6767906449167648/019fec33-ce32-70ab-9f4b-5f4deea7748b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW1CgbxMz9IgRLSGh_qbHWC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_0ade4937-3f96-402b-98fb-26120951a634",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Food Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "6169 U.S.278 NW, Covington, GA 30014, USA",
      "poi_short_description": "Discount grocery-store chain selling meat, produce & brand-name goods since 1975.",
      "poi_long_description": "Discount grocery-store chain selling meat, produce & brand-name goods since 1975.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-a4ac-7172-9314-3618b6ac2937.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-a4ac-7172-9314-3618b6ac2937",
        "storage_key": "property/6767906449167648/019fec33-a4ac-7172-9314-3618b6ac2937.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.fooddepot.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15562220352962927680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "food-depot",
      "poi_latitude": "33.6040875",
      "poi_longitude": "-83.8744286",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-787-2622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce32-70ab-9f4b-5f4deea7748b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce32-70ab-9f4b-5f4deea7748b",
        "storage_key": "property/6767906449167648/019fec33-ce32-70ab-9f4b-5f4deea7748b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjbmLSos09IgRQJy1dvUc-Nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5354459a-b0ab-4240-b526-a53f17d0c618",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Oxford College of Emory University",
      "poi_type": "Education",
      "poi_address": "801 Emory St, Oxford, GA 30054, USA",
      "poi_short_description": "Emory University's original campus in Oxford, a two-year liberal-arts college for Emory undergraduates.",
      "poi_long_description": "Emory University's original campus in Oxford, a two-year liberal-arts college for Emory undergraduates.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ab55-75de-a707-dbd6f72930ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-ab55-75de-a707-dbd6f72930ea",
        "storage_key": "property/6767906449167648/019fec33-ab55-75de-a707-dbd6f72930ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://oxford.emory.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9613297078614055299&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oxford-college-of-emory-university",
      "poi_latitude": "33.6208822",
      "poi_longitude": "-83.8675432",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-784-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce30-7354-b7be-cae1f3cac08d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce30-7354-b7be-cae1f3cac08d",
        "storage_key": "property/6767906449167648/019fec33-ce30-7354-b7be-cae1f3cac08d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3b_Nq-s09IgRg1kXc8JKaYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2fe7171c-c2c6-470c-83b7-a528d9d8bb61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Georgia State University- Perimeter College Newton Campus",
      "poi_type": "Education",
      "poi_address": "239 Cedar Ln Bldg 1N, Covington, GA 30014, USA",
      "poi_short_description": "Georgia State University's Perimeter College campus in Covington, offering associate degrees and transfer pathways.",
      "poi_long_description": "Georgia State University's Perimeter College campus in Covington, offering associate degrees and transfer pathways.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ac24-70d9-9592-7f55681ab7fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-ac24-70d9-9592-7f55681ab7fc",
        "storage_key": "property/6767906449167648/019fec33-ac24-70d9-9592-7f55681ab7fc.webp",
        "width": 670,
        "height": 1280
      },
      "poi_business_url": "https://www.gsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7213028146270988451&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "georgia-state-university--perimeter-college-newton-campus",
      "poi_latitude": "33.6070917",
      "poi_longitude": "-83.757836",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 770-278-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce30-7354-b7be-cae1f3cac08d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce30-7354-b7be-cae1f3cac08d",
        "storage_key": "property/6767906449167648/019fec33-ce30-7354-b7be-cae1f3cac08d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgfCTGWMt9IgRo2hg_eHSGWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7ce4bd63-7244-429e-a240-b444779bc113",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Covington - Frank B Turner, Sr. Library",
      "poi_type": "Education",
      "poi_address": "7116 Floyd St NE, Covington, GA 30014, USA",
      "poi_short_description": "Public library with a decent selection of books, free Wi-Fi, and private rooms, plus a kids' area.",
      "poi_long_description": "Public library with a decent selection of books, free Wi-Fi, and private rooms, plus a kids' area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ae12-77e0-bf70-c453bd46d873.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-ae12-77e0-bf70-c453bd46d873",
        "storage_key": "property/6767906449167648/019fec33-ae12-77e0-bf70-c453bd46d873.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://newtonlibraries.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5108389119926139728&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "covington---frank-b-turner-sr-library",
      "poi_latitude": "33.5993209",
      "poi_longitude": "-83.8389084",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-787-3231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce31-76be-b396-4bd07f02247b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce31-76be-b396-4bd07f02247b",
        "storage_key": "property/6767906449167648/019fec33-ce31-76be-b396-4bd07f02247b.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJN4NEfXgz9IgRUPuq09ak5EY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_e5521ea4-5833-433d-9611-923e6246c31d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Sharp Stadium",
      "poi_type": "Entertainment",
      "poi_address": "3109 Newton Dr NE, Covington, GA 30014, USA",
      "poi_short_description": "Local stadium for high school football teams, also used for graduation ceremonies.",
      "poi_long_description": "Local stadium for high school football teams, also used for graduation ceremonies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-adf4-77ff-9dab-17cd89ed2ab4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-adf4-77ff-9dab-17cd89ed2ab4",
        "storage_key": "property/6767906449167648/019fec33-adf4-77ff-9dab-17cd89ed2ab4.webp",
        "width": 939,
        "height": 626
      },
      "poi_business_url": "https://www.newtoncountyschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1091539914109828119&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sharp-stadium",
      "poi_latitude": "33.60109070000001",
      "poi_longitude": "-83.8531548",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce76-740a-a22b-8d8f98cc28cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce76-740a-a22b-8d8f98cc28cf",
        "storage_key": "property/6767906449167648/019fec33-ce76-740a-a22b-8d8f98cc28cf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl8Fdm4A09IgRFzytxsTtJQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_c567a008-0fd0-440c-b3ee-6e317137a8cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Covington Square",
      "poi_type": "Entertainment",
      "poi_address": "1105 Church St, Covington, GA 30014, USA",
      "poi_short_description": "Historic downtown square of Covington, with shops, restaurants and the Newton County courthouse.",
      "poi_long_description": "Historic downtown square of Covington, with shops, restaurants and the Newton County courthouse.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-bd4a-74de-8dd7-34d88bacba78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-bd4a-74de-8dd7-34d88bacba78",
        "storage_key": "property/6767906449167648/019fec33-bd4a-74de-8dd7-34d88bacba78.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1440494364612691567&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "covington-square",
      "poi_latitude": "33.5964159",
      "poi_longitude": "-83.8598425",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce79-777b-9709-8cf587ee8f19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce79-777b-9709-8cf587ee8f19",
        "storage_key": "property/6767906449167648/019fec33-ce79-777b-9709-8cf587ee8f19.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Y4pKQA19IgRbwaxF_6p_RM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_486c3520-a05a-41a2-80da-c64cd9c07bc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3173B Hwy 278 NE, Covington, GA 30014, USA",
      "poi_short_description": "Spacious, basic-equipment, judgment-free chain of gyms featuring circuit-training classes, weights and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of equipment for both upper and lower body workouts, and appreciate the 24/7 access. They also highlight the friendly staff and the clean, well-organized facilities. Guests mention the excellent value for a stress-free workout experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-b0be-7712-931b-1f486baaadbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-b0be-7712-931b-1f486baaadbb",
        "storage_key": "property/6767906449167648/019fec33-b0be-7712-931b-1f486baaadbb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/covington-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17745375139353358708&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.60455",
      "poi_longitude": "-83.85755999999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 470-444-1740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce69-73ef-9cf9-52c07f2ad930.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce69-73ef-9cf9-52c07f2ad930",
        "storage_key": "property/6767906449167648/019fec33-ce69-73ef-9cf9-52c07f2ad930.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2GGOZ019IgRdHE0k6s8RPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_caa336a0-1019-4556-9379-f5b65908028c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "East Metro Animal Emergency Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "6225 U.S.278 NW, Covington, GA 30014, USA",
      "poi_short_description": "After-hours veterinary emergency clinic on U.S. 278 in Covington.",
      "poi_long_description": "After-hours veterinary emergency clinic on U.S. 278 in Covington.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-afc8-71dd-bfb8-b060b563d7cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-afc8-71dd-bfb8-b060b563d7cc",
        "storage_key": "property/6767906449167648/019fec33-afc8-71dd-bfb8-b060b563d7cc.webp",
        "width": 750,
        "height": 701
      },
      "poi_business_url": "https://eastmetroemergency.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5944029727086424591&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "east-metro-animal-emergency-clinic",
      "poi_latitude": "33.6036558",
      "poi_longitude": "-83.87561230000001",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-212-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce69-73ef-9cf9-52c07f2ad930.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce69-73ef-9cf9-52c07f2ad930",
        "storage_key": "property/6767906449167648/019fec33-ce69-73ef-9cf9-52c07f2ad930.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpcjrBfQ09IgRDzJZQYtvfVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_0a441ef8-9f56-42d9-bef4-cfbdbb34f56b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Alcovy Fitness & Wellness",
      "poi_type": "Health and Wellness",
      "poi_address": "10100 Alcovy Rd, Covington, GA 30014, USA",
      "poi_short_description": "Gym featuring weight and cardio equipment, group fitness classes, a heated pool, and a sauna.",
      "poi_long_description": "Gym featuring weight and cardio equipment, group fitness classes, a heated pool, and a sauna.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-b69a-741e-8f0e-da22187596cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-b69a-741e-8f0e-da22187596cd",
        "storage_key": "property/6767906449167648/019fec33-b69a-741e-8f0e-da22187596cd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.alcovyfitness.com/membership",
      "poi_directions_map_url": "https://maps.google.com/?cid=6407240303023497525&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alcovy-fitness--wellness",
      "poi_latitude": "33.6162842",
      "poi_longitude": "-83.841838",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-385-8550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce69-73ef-9cf9-52c07f2ad930.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce69-73ef-9cf9-52c07f2ad930",
        "storage_key": "property/6767906449167648/019fec33-ce69-73ef-9cf9-52c07f2ad930.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH6OYCIk09IgRNSFIzBsX61g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0e8c21f2-42e7-43cb-917d-bbf61763e24e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Piedmont Newton",
      "poi_type": "Health and Wellness",
      "poi_address": "5126 Hospital Dr NE, Covington, GA 30014, USA",
      "poi_short_description": "Community hospital on Hospital Drive in Covington, part of the Piedmont Healthcare system, with a 24-hour emergency department.",
      "poi_long_description": "Community hospital on Hospital Drive in Covington, part of the Piedmont Healthcare system, with a 24-hour emergency department.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-bb4d-747e-9865-39a001293caa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-bb4d-747e-9865-39a001293caa",
        "storage_key": "property/6767906449167648/019fec33-bb4d-747e-9865-39a001293caa.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-newton?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTY5MTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12357037049121240309&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "piedmont-newton",
      "poi_latitude": "33.6013604",
      "poi_longitude": "-83.8478329",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-786-7053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-ce6c-77cb-8faf-efb0c95c8ba0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-ce6c-77cb-8faf-efb0c95c8ba0",
        "storage_key": "property/6767906449167648/019fec33-ce6c-77cb-8faf-efb0c95c8ba0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJH9lU1_Y09IgR9XQ2zbkDfas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a46e1618-1f63-4fbf-9d8c-c0ba60326474",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Lake Varner Reservoir",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Covington, GA 30014, USA",
      "poi_short_description": "Place to enjoy fishing and kayaking or boating, with playgrounds for kids.",
      "poi_long_description": "Visitors say this park offers beautiful lake views, picnic areas, and a playground, making it excellent for gatherings and cooking out. They also highlight the peaceful atmosphere and well-maintained walking tracks. Guests mention the free entry for county residents and the presence of police, contributing to a sense of safety.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-bc84-71e7-afb3-54058c34e618.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-bc84-71e7-afb3-54058c34e618",
        "storage_key": "property/6767906449167648/019fec33-bc84-71e7-afb3-54058c34e618.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.co.newton.ga.us/241/Lake-Varner",
      "poi_directions_map_url": "https://maps.google.com/?cid=6320992901137897288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-varner-reservoir",
      "poi_latitude": "33.65223400000001",
      "poi_longitude": "-83.7995116",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 770-784-2049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-d0b7-764e-a839-9c6ec9ed2b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-d0b7-764e-a839-9c6ec9ed2b9c",
        "storage_key": "property/6767906449167648/019fec33-d0b7-764e-a839-9c6ec9ed2b9c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP3smVS_N9YgRSBcXtI2tuFc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1ee2ddaa-75ab-4345-904e-b9325e115a50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "City Pond Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13501 City Pond Rd, Covington, GA 30014, USA",
      "poi_short_description": "Sports complex with 6 lighted baseball fields, 4 lighted tennis courts, concessions & a playground.",
      "poi_long_description": "Visitors say this park features well-maintained baseball, soccer, and football fields, along with multiple playgrounds and a peaceful pond. They also highlight the clean facilities, including spotless restrooms, and the ample parking available. Guests mention the serene atmosphere, making it a family-friendly destination.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-be8f-75cf-8720-d044c15ea465.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-be8f-75cf-8720-d044c15ea465",
        "storage_key": "property/6767906449167648/019fec33-be8f-75cf-8720-d044c15ea465.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.co.newton.ga.us/facilities/facility/details/City-Pond-2",
      "poi_directions_map_url": "https://maps.google.com/?cid=14354674926641174614&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-pond-park",
      "poi_latitude": "33.6283465",
      "poi_longitude": "-83.8444591",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-786-4373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-d0b7-764e-a839-9c6ec9ed2b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-d0b7-764e-a839-9c6ec9ed2b9c",
        "storage_key": "property/6767906449167648/019fec33-d0b7-764e-a839-9c6ec9ed2b9c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTXkglgz9IgRVlinnMoMNsc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fa903e77-d06c-4180-b875-1b4798a26c10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Newton County Turner Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6185 Turner Lake Rd NW, Covington, GA 30014, USA",
      "poi_short_description": "Park featuring a baseball field, nature trail, playground, and picnic tables, plus a fishing dock.",
      "poi_long_description": "Visitors say this park offers fantastic walking and biking trails, a nice lake for fishing, and a good ballpark for softball. They also highlight the beautiful facilities, family-friendly atmosphere, and ample parking. Guests mention the staff are welcoming, polite, and helpful, providing excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-c130-77bb-9612-07b990d84aed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-c130-77bb-9612-07b990d84aed",
        "storage_key": "property/6767906449167648/019fec33-c130-77bb-9612-07b990d84aed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.newtoncountyga.gov/Facilities/Facility/Details/Turner-Lake-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=4940698479118887044&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newton-county-turner-lake-park",
      "poi_latitude": "33.6002782",
      "poi_longitude": "-83.879499",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-786-4373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-d0b7-764e-a839-9c6ec9ed2b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-d0b7-764e-a839-9c6ec9ed2b9c",
        "storage_key": "property/6767906449167648/019fec33-d0b7-764e-a839-9c6ec9ed2b9c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2Esevg09IgRhKgx_hbjkEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8c1511db-ce3e-4221-b599-f5ceb908372f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "poi_name": "Academy Springs Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3120 Conyers St SE, Covington, GA 30014, USA",
      "poi_short_description": "A reservable pavilion can be used for private events at this compact park with a playground.",
      "poi_long_description": "Visitors say this park is a beautiful and peaceful spot, featuring a well-kept butterfly garden and a playground with equipment for various ages, including a dual swing for parents and toddlers. They also highlight its appeal for fans of \"The Vampire Diaries\" as a filming location.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-c016-73dc-8ecf-6913cfca72f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-c016-73dc-8ecf-6913cfca72f4",
        "storage_key": "property/6767906449167648/019fec33-c016-73dc-8ecf-6913cfca72f4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://covingtongalions.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6395717069459934676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "academy-springs-park",
      "poi_latitude": "33.5934111",
      "poi_longitude": "-83.8529811",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 770-786-4373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-d0b7-764e-a839-9c6ec9ed2b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-d0b7-764e-a839-9c6ec9ed2b9c",
        "storage_key": "property/6767906449167648/019fec33-d0b7-764e-a839-9c6ec9ed2b9c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN543B3w09IgR1M0P6ckmwlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    }
  ],
  "office_hours": [
    {
      "id": "ec_da806106ddaf63322d8967cd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4171e6985b460d0261870e14",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ee8e1ff07e6767c9c0ff9797",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_eb14447e92421b08959de30a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_557c37f46d6660f3800f077c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c92799ddbf27aa90dc3893cd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [
    {
      "id": "custom_5b71efcb-177e-428e-a867-4bc960d1a8a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Aspen home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Aspen",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tMf3v3VTedE"
    },
    {
      "id": "custom_4e85d063-69e8-40b2-904b-7a72211c9fea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Hemingway home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Hemingway",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=TALD1q2C247"
    },
    {
      "id": "custom_05c45000-cff5-4c1a-8dfb-cb336b322002",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Vera home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Vera",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JQjQDMfHtSU"
    }
  ],
  "faqs": [
    {
      "id": "custom_9a45251f-ee2f-462a-a5af-cc61cc8ac9c3",
      "question": "Application Fee",
      "answer": "$100 per person for all occupants over 18.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_6812fca1-3f34-4c31-858c-1267cffb8c58",
      "question": "Administration Fee & Additional Charges",
      "answer": "A one-time administration fee of $350 is required at move-in. Please review the information below regarding additional charges and fees that may arise throughout your lease term.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_a2662d0a-61e1-4f2e-9913-27e09bae53a3",
      "question": "Utility Billing Fee",
      "answer": "$11.99/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_2330782a-3ad9-407e-9e81-93653db58a20",
      "question": "Pet Fees",
      "answer": "Non-refundable pet fee of $300 for one pet ($500 for two pets). Pet rent $35/month per pet",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_cb642fd2-eced-4d1b-8c1f-91d76900c911",
      "question": "Concierge Package",
      "answer": "$10.95/month Bi-annual filter change Exterior pest control 24 hour maintenance response on emergencies Positive credit reporting",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_927ce7e0-efc5-4ad6-a977-1ca9e8e64e2e",
      "question": "Smart Home",
      "answer": "Smart Home Fee - $35/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_f490c549-cc06-4560-870d-6deb30cd637f",
      "question": "Landscape Services",
      "answer": "Single-family homes: $125/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_b426c5d6-41f3-4adf-8798-ed43c49426f8",
      "question": "Occupancy Guidelines",
      "answer": "The maximum occupancy for Quinn properties is two (2) persons per bedroom, plus one (1) additional occupant per home. Occupancy standards may vary by region based on local city, county, and state laws.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_e071bef6-a6ee-4a01-92c7-1c5bf27b9fbb",
      "question": "Application",
      "answer": "All adults, 18 years of age, or considered an adult under state law, are required to complete an application in its entirety. All occupants applying for the property must reside in the property. By acknowledging the terms and conditions outlined in the Quinn rental criteria, the Applicant confirms all information provided is true and accurate. Any falsification, fabrication, or untruthful answers and supporting documentation shall result in an automatic denial. Applicants are required, unless otherwise noted, to pay a $100.00 non-refundable application fee to authorize a background check and additional qualification processes; Properties may not be held off the market for greater than ten (10) days, unless a Quinn representative approves an extension. All applicants are required, unless otherwise specified, to pay a non-refundable $350 administration fee to secure a specific home and remove it from the market. All administration fees are non-refundable unless the application is declined. Upon Applicant approval, Leases are required to be signed within 24 hours of generation. In the event Lease is not signed within the 24-hour time Quinn may elect to cancel the application and place the home back on the market. All Applicants are required to provide valid identification. Non-US citizens applying to a home may be required to present information acknowledging the individual's right to live in the United States through the duration of the lease term. Approved applications are valid for thirty (30) days, after that time period, all Applicants must provide written consent for additional screening, credit checks, income verification, and re-qualification for a property managed by Quinn PM LLC. Any application that provides falsified or incorrect information may be subject to automatic disqualification. If an Applicant falsifies their application or supporting documentation, Quinn has the right to hold all deposits and fees paid to apply towards liquidated damages. DISCLAIMER: Rentgrow reports information about applicants in accordance with the applicable state and federal law. However, other federal, state or local laws and regulations may apply. This application, even if accepted, shall under no circumstances be considered a lease agreement between Applicant and Quinn, nor an offer to lease, and does not create a landlord/tenant relationship. No lease shall exist between an Applicant and Quinn unless and until the parties enter a fully executed Lease Agreement conditioned on the Applicant paying all required fees, security deposits, and rent. At Quinn PM LLC's sole discretion, Quinn PM LLC reserves the right to cancel an approved application, and refuse occupancy to any applicant(s) who disrupts or interferes with Landlord's business operations, or communicates with Landlord, Landlord's agents, or their employees in an unreasonable, discourteous, rude, or hostile manner.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_1eca94fd-13d0-4803-854c-8a0e233ffe03",
      "question": "Guarantors",
      "answer": "Guarantors may be accepted to support an application and must complete all required application and screening processes. Applicants who do not independently meet qualification criteria may also have the option to utilize a third-party lease guarantee program through TheGuarantors, which does not add an additional occupant or leaseholder.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_dbcce162-594f-4a20-9632-e9d9590aa54a",
      "question": "Income",
      "answer": "Income Requirements: Household income requirements are based upon the market and other qualification factors within the application process. In-State Income Verification: Proof of income being made in the state where you are wishing to rent a home is required. Examples include, but are not limited to, state taxes shown on your pay statements, an offer letter or transfer letter confirming you are beginning a new role in that state, or proof that you are a remote employee. Job Transfer/New Role: Applicants with an offer of employment or transfer of role from their existing employer are required to provide an Offer Letter or Transfer Letter on employer letterhead confirming terms of compensation and start date. The letter should be signed and dated by the offeror. Contract-Based Employment: At select communities, an additional income verification option may be available for applicants working on a contract basis. This may include providing a notarized letter on company letterhead confirming income from Human Resources, Payroll, the business owner, or a company officer. Additional documentation may be required to verify the stated income. Additional Income Sources: Social Security Benefits, Child Support, Alimony, Disability, Retirement, Pensions, VA Benefits and complete Bank Statements are accepted. Items containing redacted or otherwise altered information are subject to additional verification and/or denial. Additional Documentation: Quinn may request additional proof of income if the documents provided are insufficient. False or Altered Documentation: Applicants who provide any false, counterfeit, or other fake documentation are subject to denial, even if discovered after approval. Any falsified documents will result in a denial.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_4c7731d4-f033-4360-881b-946966810374",
      "question": "Security Deposit",
      "answer": "An applicant's security deposit is determined by the score of the applicant and may result in an increased security deposit for approval.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_fb1ed60d-4651-481e-b088-c2af0dfec559",
      "question": "Credit Report",
      "answer": "All applicant's credit history enters a scoring model to determine qualifications for each application. The SafeRent Score is determined from an analysis of information found in each applicant's consumer credit report, application, and previous rental histories (if applicable). Consumer reports may include but are not limited to payment history, bankruptcies, number and type of accounts, collection activity, outstanding debt and credit inquiries. In addition, the scoring process includes income-to-rent ratio, eviction records, and subprime credit records. Current Open Bankruptcies (Chapter 7 or 13) will result in an automatic denial. Applicants are subject to further verification at the request of a Quinn representative. For applications in the state of South Carolina: Applicant(s) does hereby consent upon completion and meeting the criteria of a credit and rental history screening, a criminal background report will be processed by Quintasen Holdings, LLC to complete screening of the consumer information report.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_12ead660-0e09-4c0a-95c1-65b51a2c48f8",
      "question": "Rental History",
      "answer": "Prior Evictions, filed or enforced, may result in an automatic denial of the application. Any outstanding debt or judgment owed to any prior landlord may result in a denial. Quinn may request rental verification if rental history cannot be verified.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_a0716667-8603-4251-ab0d-78346a16940b",
      "question": "Criminal History",
      "answer": "Each Applicant is subject to a criminal background check. Criminal background screening is broken into the following categories 1) Crimes Against Persons, 2) Property, and 3) Society. Criminal histories presented through applicant screening reports pertaining to weapons, drugs, violence, or any other act that poses a threat to household, neighborhood, vendors, Quinn employees, or the physical property itself, may result in a denial. Criminal history will be assessed on the risk to persons or property by an applicant including but not limited to the type of crime; the severity of the crime; circumstance of the crime; and the length of time since the crime occurred. Denied Applicants may dispute any wrongful record claims by contacting Screening Works and following the process as outlined in their action letter and Screening Works. Criminal background screening is also governed by federal, state or local laws which regulate Quinn's screening processes. An Office of Foreign Assets Control (OFAC) search is completed for each Applicant. If Applicant appears on the OFAC list, the application will be denied.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_44d7b0df-3433-4d3f-872f-6e459dc80b05",
      "question": "Pets",
      "answer": "Pet Screening: Mandatory for all applicants before move-in. Pet Restrictions: Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained from Quinn Property Management. Fees: Non-refundable pet fee of $300 for one pet; $500 for up to two pets. Monthly pet rent of $35 per pet. Prohibited Animals: Dangerous or poisonous animals and exotic pets are not permitted. Fish Tanks: Limited to 20 gallons. No pet fee or pet rent required for fish. Assistive Animals: Animals assisting persons with disabilities are exempt from these restrictions and are not considered pets. Vaccinations and Registrations: All pets must have up-to-date vaccinations and current state, city, and county registrations. Visiting Animals: No visiting animals allowed under any circumstances.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_a3908501-113a-4c26-9d25-098fd83ddf10",
      "question": "Assistance Animals",
      "answer": "No Cost - Pet screening is mandatory as part of the application process prior to move in with a 2-5 business day approval turnaround time. Assistive Animals for persons with disabilities are not considered to be pets and are not subject to the pet restrictions bestowed in this section.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_9a68a55f-04da-4e6b-91ac-73ecbc05f49f",
      "question": "Vehicles",
      "answer": "No more than four (4) vehicles are permitted on the Premises. Vehicles must be operational and have current and valid registration based upon state law. Additional HOA restrictions may apply to the number of vehicles, commercial vehicles and allowed parking locations. If your home is contained in an HOA review the HOA's restrictive covenants for more information regarding vehicle guidelines.",
      "category": "Vehicles",
      "source": "custom"
    },
    {
      "id": "custom_51ffe5a6-ba30-42b5-9d71-31be8ed82c12",
      "question": "Renters Insurance",
      "answer": "To alleviate concerns and help you protect what matters most we have partnered with Assurant, a preferred insurance provider, to make the process of protecting your home and property seamless. We know how busy life can be, and we wanted to provide you an option that makes the selection of an insurance policy simple, while meeting your lease requirements. Please visit this page for more information on renters insurance requirements.",
      "category": "Renters Insurance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_9099ad5143e1b79ead3c4595",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "2454342",
      "pet_type": "all",
      "allowed": true,
      "max_count": 3,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    },
    {
      "id": "ec_d0215cf1749c862a3a0cb412",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "2463097",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_d0741f1032fcbc8d9c912a0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "yardi",
      "external_id": "2463096",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-9e3c-763a-8b14-15b7415ec23b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Quinn Residences at Dorchester Place Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648"
    },
    {
      "lead_collector_id": "01a0abe0-9ead-714d-85bf-99abfe9e4aec",
      "lead_source": "LANDING_PAGE",
      "name": "Quinn Residences at Dorchester Place Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "quinn-residences-apartments-with-in-unit-laundry-covington-ga",
      "search_query": "apartments with in-unit laundry Covington GA",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Covington, GA",
      "h2_subtitle": "Discover apartments with in-unit laundry at Quinn Residences. Enjoy the convenience of laundry facilities right inside your Covington, GA apartment.",
      "page_copy": "Discover apartments with in-unit laundry in Covington, GA, at Quinn Residences at Dorchester Place. Enjoy the convenience of having a washer and dryer at home, along with modern features like smart-home technology and stainless steel appliances that make everyday living easier.\n\nOur thoughtfully designed apartments also feature spacious closets and luxury flooring, combining practical conveniences with contemporary style. Located in Newton County, Quinn Residences at Dorchester Place offers modern apartment living with the features you want in a place to call home. Explore our Covington, GA apartments with in-unit laundry and discover your next home today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Covington, GA",
      "seo_description": "Find apartments with in-unit laundry at Quinn Residences in Covington, GA. Modern amenities and comfortable living await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "quinn-residences-private-fenced-in-yard-newton-county",
      "search_query": "private fenced-in yard Newton County apartments",
      "category": "Amenity",
      "h1_title": "Newton County Apartments with Private Yards",
      "h2_subtitle": "Explore Newton County apartments featuring private fenced-in yards. Experience outdoor tranquility at Quinn Residences with our exclusive amenities.",
      "page_copy": "Discover apartments with private fenced-in yards in Covington, GA, at Quinn Residences at Dorchester Place. Enjoy the convenience of having your own outdoor space, offering more room to relax, unwind, or enjoy time outside. Located in Newton County, our community combines modern apartment living with thoughtful features designed for everyday comfort.\n\nInside, explore contemporary finishes and conveniences, including smart-home technology, in-unit laundry, stainless steel appliances, and luxury flooring. With private outdoor spaces and stylish interiors, Quinn Residences at Dorchester Place brings comfort, functionality, and convenience together. Explore our Covington, GA apartments with private fenced-in yards and discover your next home today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Newton County Apartments with Private Yards",
      "seo_description": "Discover Newton County apartments at Quinn Residences with private fenced-in yards. Enjoy modern amenities and serene outdoor spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "quinn-residences-smart-home-tech-apartments-near-30014",
      "search_query": "smart-home technology apartments near 30014",
      "category": "Amenity",
      "h1_title": "Smart-Home Technology Apartments Near 30014",
      "h2_subtitle": "Explore apartments near 30014 equipped with smart-home technology. Live conveniently at Quinn Residences, where innovation meets comfort.",
      "page_copy": "Discover apartments with smart-home technology in Covington, GA 30014, at Quinn Residences at Dorchester Place. Enjoy modern features designed to bring convenience and functionality to everyday living, with smart-home technology that puts added control and comfort at your fingertips.\n\nBeyond smart-home features, our apartments offer luxury flooring, in-unit laundry, and spacious closets, combining contemporary finishes with practical conveniences. Located in Newton County, Quinn Residences at Dorchester Place brings modern apartment living and thoughtful design together. Explore our Covington, GA apartments with smart-home technology and discover your next home today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart-Home Tech Apartments Near 30014",
      "seo_description": "Discover smart-home technology apartments near 30014 at Quinn Residences. Modern living with premium amenities awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "quinn-residences-apartments-lawn-maintenance-covington",
      "search_query": "apartments with lawn maintenance Covington",
      "category": "Amenity",
      "h1_title": "Lawn Maintenance Apartments in Covington",
      "h2_subtitle": "Find apartments with lawn maintenance in Covington at Quinn Residences. Enjoy hassle-free living in a well-maintained environment.",
      "page_copy": "Discover apartments with lawn maintenance in Covington, GA, at Quinn Residences at Dorchester Place. Enjoy the convenience of maintained outdoor spaces, giving you more time to relax and enjoy the comforts of home. Located in Newton County, our community combines thoughtful services with modern apartment features designed for everyday convenience.\n\nInside, explore contemporary amenities including smart-home technology, stainless steel appliances, in-unit laundry, luxury flooring, and spacious closets. With lawn maintenance and stylish interiors, Quinn Residences at Dorchester Place brings comfort, functionality, and convenience together. Explore our Covington, GA apartments with lawn maintenance and discover your next home today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lawn Maintenance Apartments in Covington",
      "seo_description": "Enjoy hassle-free living with lawn maintenance at Quinn Residences in Covington. Experience modern amenities and a pristine environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "quinn-residences-luxury-flooring-apartments-covington-ga",
      "search_query": "luxury flooring apartments in Covington GA",
      "category": "Amenity",
      "h1_title": "Luxury Flooring Apartments in Covington, GA",
      "h2_subtitle": "Discover apartments with luxury flooring in Covington, GA at Quinn Residences. Experience superior quality and comfort in every step.",
      "page_copy": "Discover apartments with luxury flooring in Covington, GA, at Quinn Residences at Dorchester Place. Enjoy thoughtfully designed interiors featuring stylish flooring that adds a contemporary touch to your living space. With modern finishes and practical features, our apartments combine comfort, style, and everyday functionality.\n\nBeyond luxury flooring, our residences offer in-unit laundry, spacious closets, and smart-home technology designed to make daily living more convenient. Located in Newton County, Quinn Residences at Dorchester Place brings contemporary apartment living and thoughtful design together. Explore our Covington, GA apartments with luxury flooring and discover your next home today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Flooring Apartments in Covington, GA",
      "seo_description": "Experience luxury flooring in Covington, GA at Quinn Residences. Enjoy superior comfort with modern amenities and stylish interiors.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "quinn-residences-three-bedroom-apartments-covington-ga",
      "search_query": "three bedroom apartments in Covington GA",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Covington, GA",
      "h2_subtitle": "Explore spacious three-bedroom apartments in Covington, GA, at Quinn Residences. ",
      "page_copy": "Looking for spacious three-bedroom apartments in Covington, GA? Quinn Residences at Dorchester Place offers thoughtfully designed layouts that combine comfort, style, and everyday functionality. Enjoy generous living spaces, spacious closets, and luxury flooring that bring a modern touch to your home.\n\nBeyond the roomy interiors, our three-bedroom apartments feature smart-home technology and in-unit laundry, adding convenience to your daily routine. Located in Newton County, Quinn Residences at Dorchester Place offers the space and modern features you need to make yourself at home. Explore our three-bedroom apartments in Covington, GA, and discover your next home today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Covington, GA",
      "seo_description": "Find spacious three bedroom apartments in Covington, GA at Quinn Residences, offering modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "quinn-residences-four-bedroom-apartments-near-newton-county",
      "search_query": "four bedroom apartments near Newton County",
      "category": "Floorplan",
      "h1_title": "Four Bedroom Apartments Near Newton County",
      "h2_subtitle": "Discover expansive four-bedroom apartments near Newton County at Quinn Residences.",
      "page_copy": "Discover spacious four-bedroom apartments in Covington, GA, at Quinn Residences at Dorchester Place. Our thoughtfully designed residences offer generous living spaces, luxury flooring, and spacious closets, combining contemporary style with everyday functionality.\n\nEnjoy modern apartment features, including stainless steel appliances, in-unit laundry, and smart-home technology designed to bring convenience to your daily routine. Located in Newton County, Quinn Residences at Dorchester Place offers a blend of comfort, style, and accessibility to nearby destinations. Explore our four-bedroom apartments in Covington, GA, and discover your next home today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Apartments Near Newton County",
      "seo_description": "Explore four bedroom apartments near Newton County at Quinn Residences, offering superior amenities and ample space.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "quinn-residences-five-bedroom-apartments-dorchester-place-30014",
      "search_query": "five bedroom apartments Dorchester Place 30014",
      "category": "Floorplan",
      "h1_title": "Five Bedroom Apartments Dorchester Place 30014",
      "h2_subtitle": "Discover spacious five bedroom apartments at Dorchester Place in the 30014 area.",
      "page_copy": "Discover spacious five-bedroom apartments in Covington, GA 30014, at Quinn Residences at Dorchester Place. Our thoughtfully designed residences offer generous living spaces, luxury flooring, and spacious closets, combining contemporary style with everyday functionality.\n\nEnjoy modern conveniences, including smart-home technology, in-unit laundry, and stainless steel appliances, all designed to bring comfort and practicality to your daily routine. Located in Newton County, Quinn Residences at Dorchester Place offers convenient access to nearby shopping, dining, and local attractions. Explore our five-bedroom apartments in Covington, GA, and discover your next home today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Five Bedroom Apartments Dorchester Place 30014",
      "seo_description": "Find five bedroom apartments at Dorchester Place, Covington, 30014, featuring spacious layouts and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "quinn-residences-apartments-near-oxford-college-covington",
      "search_query": "apartments near oxford college of emory university in covington",
      "category": "School",
      "h1_title": "Apartments Near Oxford College of Emory University",
      "h2_subtitle": "Find exceptional living at Quinn Residences, located near Oxford College of Emory University in Covington, GA.",
      "page_copy": "Discover modern apartment living near Oxford College of Emory University at Quinn Residences at Dorchester Place in Covington, GA. Our community offers convenient access to the college and destinations throughout Newton County, combining a desirable location with thoughtfully designed interiors and everyday conveniences.\n\nExplore apartments featuring spacious closets, in-unit laundry, stainless steel appliances, smart-home technology, and luxury flooring. With contemporary finishes and practical features, Quinn Residences at Dorchester Place brings comfort, style, and functionality together. Explore our apartments near Oxford College of Emory University and discover your next home in Covington, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oxford College of Emory University",
      "seo_description": "Discover apartments near Oxford College of Emory University in Covington with modern amenities at Quinn Residences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "quinn-residences-apartments-close-to-gsu-perimeter-newton-campus",
      "search_query": "apartments close to georgia state university perimeter college newton campus 30014",
      "category": "School",
      "h1_title": "Apartments Close to Georgia State University Newton",
      "h2_subtitle": "Find your new home at Quinn Residences, only a short drive from Georgia State University's Perimeter College Newton Campus.",
      "page_copy": "Discover modern apartments near Georgia State University's Perimeter College Newton Campus at Quinn Residences at Dorchester Place in Covington, GA. Our community offers convenient access to the campus and destinations throughout Newton County, combining a desirable location with thoughtfully designed interiors and everyday conveniences.\n\nExplore apartments featuring stainless steel appliances, in-unit laundry, luxury flooring, spacious closets, and smart-home technology. With contemporary finishes and practical features, Quinn Residences at Dorchester Place brings comfort, style, and functionality together. Explore our apartments near Georgia State University's Perimeter College Newton Campus and discover your next home in Covington, GA 30014.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Georgia State University Newton",
      "seo_description": "Discover apartments near Georgia State University's Newton Campus, with modern amenities and an ideal location at Quinn Residences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "quinn-residences-apartments-near-piedmont-newton-covington",
      "search_query": "apartments near Piedmont Newton in Covington GA",
      "category": "Hospital",
      "h1_title": "Apartments Near Piedmont Newton, Covington GA",
      "h2_subtitle": "Explore comfortable living options at Quinn Residences near Piedmont Newton in Covington, GA, combining modern amenities with a prime location.",
      "page_copy": "Looking for apartments near Piedmont Newton Hospital in Covington, GA? Quinn Residences at Dorchester Place offers a convenient location with access to nearby healthcare facilities, shopping, dining, and destinations throughout Newton County.\n\nDiscover modern apartment living with smart-home technology, luxury flooring, spacious closets, stainless steel appliances, and in-unit laundry. With thoughtfully designed interiors and everyday conveniences, Quinn Residences at Dorchester Place brings comfort and functionality together. Explore our apartments in Covington, GA, and find your next home today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Piedmont Newton, Covington GA",
      "seo_description": "Find apartments near Piedmont Newton in Covington, GA, with modern amenities and convenient access at Quinn Residences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "quinn-residences-covington-ga-close-to-piedmont-newton",
      "search_query": "Quinn Residences Covington GA close to Piedmont Newton",
      "category": "Hospital",
      "h1_title": "Quinn Residences: Close to Piedmont Newton",
      "h2_subtitle": "Discover the convenience of Quinn Residences in Covington, GA, just moments away from Piedmont Newton. ",
      "page_copy": "Located in Covington, GA, Quinn Residences at Dorchester Place offers convenient access to Piedmont Newton Hospital and destinations throughout Newton County. Our apartments combine a desirable location with modern features designed to bring comfort and convenience to everyday living.\n\nDiscover thoughtfully designed interiors featuring luxury flooring, spacious closets, stainless steel appliances, in-unit laundry, and smart-home technology. Whether you're exploring the neighborhood or enjoying the comforts of home, Quinn Residences at Dorchester Place offers a blend of modern living and everyday convenience. Explore our apartments near Piedmont Newton Hospital and discover your next home in Covington, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Quinn Residences: Close to Piedmont Newton",
      "seo_description": "Quinn Residences, located in Covington GA, offers modern living close to Piedmont Newton with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "dorchester-place-apts-next-to-piedmont-newton-30014",
      "search_query": "Dorchester Place apts next to Piedmont Newton 30014",
      "category": "Hospital",
      "h1_title": "Dorchester Place Apts: Next to Piedmont Newton",
      "h2_subtitle": "Experience modern living at Dorchester Place Apts, ideally situated next to Piedmont Newton in the heart of Covington, GA, 30014.",
      "page_copy": "Discover convenient apartment living near Piedmont Newton Hospital at Quinn Residences at Dorchester Place in Covington, GA 30014. Our community offers access to nearby healthcare facilities and destinations throughout Newton County, combining a desirable location with modern apartment features.\n\nEnjoy thoughtfully designed interiors with spacious closets, luxury flooring, in-unit laundry, stainless steel appliances, and smart-home technology. With everyday conveniences and contemporary finishes, Quinn Residences at Dorchester Place makes it easy to enjoy the comforts of home. Explore our apartments near Piedmont Newton Hospital and discover your next home in Covington, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dorchester Place Apts: Next to Piedmont Newton",
      "seo_description": "Discover Dorchester Place Apartments, next to Piedmont Newton in Covington GA, 30014, featuring modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "covington-apartments-by-piedmont-newton-hospital",
      "search_query": "Covington apartments by Piedmont Newton Hospital",
      "category": "Hospital",
      "h1_title": "Covington Apartments by Piedmont Newton Hospital",
      "h2_subtitle": "Find the perfect living space at Quinn Residences, conveniently located by Piedmont Newton Hospital in Covington, GA.",
      "page_copy": "Quinn Residences at Dorchester Place offers modern apartment living in Covington, GA, with convenient access to Piedmont Newton Hospital and destinations throughout Newton County. Our community combines a desirable location with thoughtfully designed interiors and everyday conveniences.\n\nExplore apartments featuring spacious closets, stainless steel appliances, smart-home technology, luxury flooring, and in-unit laundry. With contemporary finishes and features designed for comfort and functionality, Quinn Residences at Dorchester Place brings modern living and convenience together. Discover our apartments near Piedmont Newton Hospital and find your next home in Covington, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Covington Apartments by Piedmont Newton Hospital",
      "seo_description": "Explore Covington apartments by Piedmont Newton Hospital at Quinn Residences with modern amenities and an ideal location in GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "newton-county-living-near-piedmont-newton",
      "search_query": "Newton County living near Piedmont Newton",
      "category": "Hospital",
      "h1_title": "Newton County Living Near Piedmont Newton",
      "h2_subtitle": "Discover the benefits of Newton County living at Quinn Residences, perfectly situated near Piedmont Newton Hospital for unmatched convenience.",
      "page_copy": "Discover modern apartment living in Covington, GA, at Quinn Residences at Dorchester Place. Conveniently located near Piedmont Newton Hospital, our community offers access to healthcare services and destinations throughout Newton County.\n\nExplore thoughtfully designed apartments featuring smart-home technology, stainless steel appliances, spacious closets, luxury flooring, and in-unit laundry. With contemporary finishes and everyday conveniences, Quinn Residences at Dorchester Place combines comfort, style, and functionality. Discover our apartments near Piedmont Newton Hospital and find your next home in Covington, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Newton County Living Near Piedmont Newton",
      "seo_description": "Experience Newton County living near Piedmont Newton at Quinn Residences, featuring modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "apartments-near-lake-varner-reservoir-covington-ga",
      "search_query": "apartments near Lake Varner Reservoir Covington GA",
      "category": "Park",
      "h1_title": "Apts Near Lake Varner Reservoir in Covington",
      "h2_subtitle": "Explore serene living at Quinn Residences, conveniently located near Lake Varner Reservoir in Covington, GA, offering a tranquil community setting.",
      "page_copy": "Discover modern apartment living in Covington, GA, at Quinn Residences at Dorchester Place. Located within reach of Lake Varner Reservoir and destinations throughout Newton County, our community offers a convenient location for exploring nearby outdoor recreation, shopping, dining, and local attractions.\n\nEnjoy thoughtfully designed apartments featuring smart-home technology, luxury flooring, stainless steel appliances, spacious closets, and in-unit laundry. With contemporary finishes and everyday conveniences, Quinn Residences at Dorchester Place combines comfort, style, and functionality. Explore our apartments near Lake Varner Reservoir and discover your next home in Covington, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Lake Varner Reservoir in Covington",
      "seo_description": "Discover apartments near Lake Varner Reservoir in Covington, GA at Quinn Residences with luxury amenities in a serene community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "quinn-residences-close-to-city-pond-park",
      "search_query": "Quinn Residences close to City Pond Park Newton County",
      "category": "Park",
      "h1_title": "Quinn Residences Near City Pond Park",
      "h2_subtitle": "Enjoy modern living at Quinn Residences, conveniently located close to City Pond Park in Newton County, offering both comfort and convenience.",
      "page_copy": "Discover modern apartment living in Covington, GA, at Quinn Residences at Dorchester Place. Conveniently located near City Pond Park, our community offers access to outdoor recreation and destinations throughout Newton County. Explore nearby green spaces and local attractions while enjoying the comforts of home.\n\nOur apartments feature luxury flooring, in-unit laundry, stainless steel appliances, spacious closets, and smart-home technology. With contemporary finishes and everyday conveniences, Quinn Residences at Dorchester Place brings comfort, style, and functionality together. Explore our apartments near City Pond Park and discover your next home in Covington, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Quinn Residences Near City Pond Park",
      "seo_description": "Discover Quinn Residences near City Pond Park in Newton County, offering modern amenities and convenient access to outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "apartments-near-turner-lake-park-newton-county-ga",
      "search_query": "apartments near Newton County Turner Lake Park GA",
      "category": "Park",
      "h1_title": "Apts Near Turner Lake Park in Newton County",
      "h2_subtitle": "Discover peaceful apartments near Turner Lake Park in Newton County, GA, at Quinn Residences, offering a perfect blend of comfort and convenience.",
      "page_copy": "Discover modern apartment living in Covington, GA, at Quinn Residences at Dorchester Place. Located near Turner Lake Park, our community offers convenient access to outdoor recreation, scenic green spaces, and destinations throughout Newton County. Enjoy exploring nearby parks and local attractions while having a comfortable place to call home.\n\nOur apartments feature smart-home technology, luxury flooring, stainless steel appliances, spacious closets, and in-unit laundry. With contemporary finishes and everyday conveniences, Quinn Residences at Dorchester Place combines comfort, style, and functionality. Explore our apartments near Turner Lake Park and discover your next home in Covington, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Turner Lake Park in Newton County",
      "seo_description": "Explore apartments near Turner Lake Park, GA at Quinn Residences, featuring modern amenities and access to recreation in Newton County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "apartments-close-to-spring-hill-park-newton-county",
      "search_query": "apartments close to Spring Hill Park Newton County",
      "category": "Park",
      "h1_title": "Apts Close to Spring Hill Park",
      "h2_subtitle": "Discover apartments near Spring Hill Park in Newton County at Quinn Residences, combining modern amenities with a convenient location.",
      "page_copy": "Discover modern apartment living in Covington, GA, at Quinn Residences at Dorchester Place. Located near Spring Hill Park, our community offers convenient access to outdoor recreation, green spaces, and destinations throughout Newton County. Explore nearby natural surroundings while enjoying the comforts of home.\n\nOur apartments feature luxury flooring, in-unit laundry, smart-home technology, stainless steel appliances, and spacious closets. With contemporary finishes and everyday conveniences, Quinn Residences at Dorchester Place brings comfort, style, and functionality together. Explore our apartments near Spring Hill Park and discover your next home in Covington, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Spring Hill Park in Newton County",
      "seo_description": "Find apartments close to Spring Hill Park, Newton County at Quinn Residences, offering modern living near serene parkland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167648",
      "source": "custom",
      "page_item_url": "quinn-residences-near-academy-springs-park-covington",
      "search_query": "Quinn Residences near Academy Springs Park Covington 30014",
      "category": "Park",
      "h1_title": "Quinn Residences by Academy Springs Park",
      "h2_subtitle": "Live near Academy Springs Park at Quinn Residences, Covington, 30014, where comfort meets convenience in an ideal location.",
      "page_copy": "Discover modern apartment living in Covington, GA, at Quinn Residences at Dorchester Place. Located near Academy Springs Park, our community offers access to outdoor recreation, green spaces, and destinations throughout Newton County. Enjoy exploring nearby parks and local attractions while having a comfortable place to call home.\n\nOur apartments feature smart-home technology, stainless steel appliances, luxury flooring, spacious closets, and in-unit laundry. With contemporary finishes and everyday conveniences, Quinn Residences at Dorchester Place combines comfort, style, and functionality. Explore our apartments near Academy Springs Park and discover your next home in Covington, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Quinn Residences by Academy Springs Park",
      "seo_description": "Explore Quinn Residences near Academy Springs Park, Covington, 30014, offering modern amenities and proximity to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977245162"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MN2JJKPH"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57164284979"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/10pdg82yp2z"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/ddc1ff4f-6972-4fad-a24c-2499ef561dc7/units"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "f575f682-ff93-11ef-9459-875bc4d02085"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-838-8219"
    },
    {
      "ID": "custom_paid_social_tracking_phone_number",
      "type": "STRING",
      "value": "866-738-1221"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977245162",
  "custom_google_gtm_id": "GTM-MN2JJKPH",
  "custom_rollout_phase": "Phase 2",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57164284979",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/10pdg82yp2z",
  "custom_self_guided_tour_url": "https://selftournow.com/property/ddc1ff4f-6972-4fad-a24c-2499ef561dc7/units",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "f575f682-ff93-11ef-9459-875bc4d02085",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_ppc_tracking_phone_number": "866-838-8219",
  "custom_paid_social_tracking_phone_number": "866-738-1221",
  "custom_audioeye_site_id": "3891c0cf-7bc7-470e-b907-b42283dd14a7",
  "custom_audioeye_site_hash": "24995e157bf779462f57d7ab3929fc03"
};

export const generatedAt = '2026-10-29T18:32:41.822Z';
